module.exports = __webpack_public_path__ + "static/media/the78boler-IG-2.c09fc2a5.PNG";